/* HeyBear · FAQ page: topic chips + side menu (built from the Topic blocks), live search with highlight,
   scroll-spy and #anchor opening (e.g. /pages/faq#shipping from the footer). */
HB.section('faq-page', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var off = [], on = function (el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  HB.reveal(root);
  var nav = $('#fqNav'), chips = $('#fqChips'), search = $('#fqSearch'), groups = $$('.fq-group'), qs = $$('.fq-q');
  var title = function (g) { var h = g.querySelector('h2'); return h ? h.firstChild.textContent.trim() : ''; };
  nav.innerHTML = groups.map(function (g) { return '<a href="#' + g.id + '" data-id="' + g.id + '">' + esc(title(g)) + '<span>' + g.querySelectorAll('.fq-q').length + '</span></a>'; }).join('');
  chips.innerHTML = '<button type="button" class="fq-chip" aria-pressed="true" data-id="">' + esc(chips.getAttribute('data-all') || 'All') + ' <i>' + qs.length + '</i></button>' +
    groups.map(function (g) { return '<button type="button" class="fq-chip" aria-pressed="false" data-id="' + g.id + '">' + esc(title(g)) + '</button>'; }).join('');
  var filt = '';
  qs.forEach(function (d) { d.__txt = d.textContent.toLowerCase(); d.__raw = d.querySelector('.qt').textContent; });
  function apply() {
    var term = search.value.trim().toLowerCase(), shown = 0;
    groups.forEach(function (g) {
      var any = 0;
      [].slice.call(g.querySelectorAll('.fq-q')).forEach(function (d) {
        var ok = (!filt || g.id === filt) && (!term || d.__txt.indexOf(term) > -1);
        d.hidden = !ok; if (ok) { any++; shown++; }
        var qt = d.querySelector('.qt'), raw = d.__raw;
        if (term && ok) { var i = raw.toLowerCase().indexOf(term); qt.innerHTML = i < 0 ? esc(raw) : esc(raw.slice(0, i)) + '<mark>' + esc(raw.slice(i, i + term.length)) + '</mark>' + esc(raw.slice(i + term.length)); }
        else qt.textContent = raw;
        if (term && ok && !d.open && shown <= 3) d.open = true;
      });
      g.hidden = !any;
    });
    $('#fqEmpty').hidden = shown > 0; $('#fqTerm').textContent = term;
  }
  var smooth = HB.reduce ? 'auto' : 'smooth';
  on(search, 'input', apply);
  on(window, 'keydown', function (e) { var t = document.activeElement && document.activeElement.tagName; if (e.key === '/' && t !== 'INPUT' && t !== 'TEXTAREA') { e.preventDefault(); search.focus(); } });
  on(chips, 'click', function (e) {
    var b = e.target.closest('.fq-chip'); if (!b) return;
    filt = b.getAttribute('data-id'); $$('.fq-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b); }); apply();
    if (filt) document.getElementById(filt).scrollIntoView({ behavior: smooth });
  });
  on(nav, 'click', function (e) {
    var a = e.target.closest('a'); if (!a) return; e.preventDefault();
    var g = document.getElementById(a.getAttribute('data-id'));
    if (g.hidden) { filt = ''; $$('.fq-chip').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-id') === ''); }); search.value = ''; apply(); }
    g.scrollIntoView({ behavior: smooth });
  });
  /* scroll spy */
  var links = $$('#fqNav a');
  var spy = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('on', l.getAttribute('data-id') === en.target.id); }); }); }, { rootMargin: '-30% 0px -60% 0px' });
  groups.forEach(function (g) { spy.observe(g); }); off.push(function () { spy.disconnect(); });
  /* open from #hash, else open the first question */
  var h = decodeURIComponent(location.hash.slice(1)), tgt = h && document.getElementById(h);
  if (tgt && root.contains(tgt)) {
    var grp = tgt.closest('.fq-group') || tgt, d = tgt.closest('.fq-q') || grp.querySelector('.fq-q');
    if (d) d.open = true; setTimeout(function () { grp.scrollIntoView(); }, 300);
  } else if (qs[0]) qs[0].open = true;
  return function () { off.forEach(function (fn) { fn(); }); };
});
